import { TApplicationState } from '../../types/redux';

export function getGaGeoLabel(state: TApplicationState): string {
  const {
    newbuilding: { gaGeoLabel },
  } = state;

  return gaGeoLabel;
}
